import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockPath } from '../../CurrentBlockProvider';
import { OutlinedContainer } from '../../../../components/OutlinedContainer';
import Styles from '../../../../assets/js/Styles';
import CheckboxInput from '../../../../components/forms/CheckboxInput';

export const EventsDisplayOptions: FC<{ blockPath: BlockPath }> = ({ blockPath }) => {
  const { t } = useTranslation('components');
  return (
    <OutlinedContainer
      label={`${t('PageListManualBlock.DisplayInputs.Label')}:`}
      fullWidth
      wrap
      sx={{
        backgroundColor: '#fff',
        justifyContent: 'flex-start!important',
        flexFlow: 'row',
        flexWrap: 'wrap',
      }}>
      <CheckboxInput
        fullWidth={false}
        path={`${blockPath}.displayInsertTitle`}
        label={t('PageListManualBlock.DisplayInputs.displayInsertTitle')}
      />
      <CheckboxInput
        fullWidth={false}
        path={`${blockPath}.displayCategory`}
        label={t('EventsBlock.DisplayOptions.Category')}
      />
      <CheckboxInput
        fullWidth={false}
        path={`${blockPath}.displayDescription`}
        label={t('EventsBlock.DisplayOptions.Description')}
      />
      <CheckboxInput
        fullWidth={false}
        path={`${blockPath}.displayLocation`}
        label={t('EventsBlock.DisplayOptions.Location')}
      />
      <CheckboxInput
        fullWidth={false}
        path={`${blockPath}.displayMuseum`}
        label={t('EventsBlock.DisplayOptions.Museum')}
      />
    </OutlinedContainer>
  );
};

export default EventsDisplayOptions;
